import "../../lib/tappay-v5.1.0"

export const TappayForm = () => ({
  app_id: null,
  app_key: null,
  env: null,
  canGetPrime: false,
  prime: null,
  firstsix: null,
  lastfour: null,
  status: "付款",

  init() {
    this.app_id = this.$el.dataset.appId
    this.app_key = this.$el.dataset.appKey
    this.env = this.$el.dataset.env


    // 驗證必要的設定參數
    if (!this.app_id || !this.app_key || !this.env) {
      this.status = "付款系統設定錯誤"
      return
    }

    if (typeof TPDirect === "undefined") {
      this.status = "付款系統載入失敗"
      return
    }

    try {
      TPDirect.setupSDK(this.app_id, this.app_key, this.env)
      TPDirect.card.setup(this.$refs.cardField, this.styles(), this.options())
      TPDirect.card.onUpdate((update) => {
        this.canGetPrime = update.canGetPrime
      })
      this.status = "付款"
    } catch (error) {
      this.status = "付款系統初始化失敗"
    }
  },

  getPrime() {

    if (!this.canGetPrime) {
      this.status = "請輸入完整的信用卡資訊"
      return
    }

    this.status = "正在處理..."

    // TapPay v5.1.0 的標準語法 - 不傳遞金額參數，金額驗證在後端處理
    TPDirect.card.getPrime((result) => {

      if (result.status !== 0) {
        this.status = "信用卡資訊有誤"
        setTimeout(() => {
          this.status = "付款"
        }, 2000)
        return
      }

      this.prime = result.card.prime
      this.firstsix = result.card.first_six
      this.lastfour = result.card.last_four


      if (this.prime) {
        this.status = "準備付款中..."
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      }
    })
  },

  styles() {
    return {}
  },

  options() {
    return {
      isUsedCcv: true,
    }
  },
})
